import React, { ReactNode,useState, useRef, useEffect } from 'react';
import PdfViewer from './pdfPreview.tsx';
import ProgressApp from './SpinnerAndTime.tsx'
import AnagraficApp from './Anagrafica.tsx';
import ErrorPopup from "./show_error.tsx";
import { Tooltip } from 'react-tooltip';
import TextareaAutosize from 'react-textarea-autosize';
import useFirestoreData, { auth, realtimeDb, addErrorLog, saveHash, useFileCaricati, salvaStatisticheUtilizzo, 
  aggiornaStatoFileCliente, ChangeOneVariable, OptionsState, initialOptions, addCliente}  from '../FirestoreDataLoader.tsx';
import {AggiornaAnagrafica, DataDict} from './UpdateAnagrafica.tsx';
import ModalRecalculateC, {messageBox, fileMessages, handleRicalcola} from './RecalculateCurrency.tsx';
import { Avatar, Button,Dialog,DialogTitle,DialogContent,DialogActions,Divider, IconButton } from '@mui/material';
import {creaXmlFattura, XmlEditorModal} from './CreaXml.tsx';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DescriptionIcon from '@mui/icons-material/Description';
import WarningIcon from '@mui/icons-material/Warning';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import ManageAccounts from '@mui/icons-material/ManageAccounts';
import EditIcon from '@mui/icons-material/Edit';
import Help from '@mui/icons-material/HelpOutlineRounded'
import PdfSplitterModal from './PdfSplitter.tsx';
import { motion, AnimatePresence } from "framer-motion";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useConfirmToast } from "../alertFunction.tsx";
import { useFileContext } from "../arrayFileContext.tsx";
import { PdfHelperTutorial } from '../Tutorial.tsx';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged, User } from "firebase/auth";
import { ref as databaseRef, onDisconnect, update , onValue} from "firebase/database";
import 'react-tooltip/dist/react-tooltip.css';
import '../styles.css';


const keysMapping : { [key :string]: string } =  {
  "IdPaese_T": "Paese trasmittente", "IdCodice_T":"Codice trasmittente", "IdPaese_P": "Paese fornitore",
  "IdCodice_P":"Codice fornitore", "Denominazione_P": "Denominazione fornitore", "Indirizzo_P": "Indirizzo fornitore",
  "CAP_P": "CAP fornitore", "Comune_P": "Comune fornitore", "Nazione_P": "Nazione fornitore",
  "IdPaese_C": "Paese cliente", "IdCodice_C":"Codice cliente", "Denominazione_C": "Denominazione cliente",
  "Indirizzo_C": "Indirizzo cliente", "CAP_C": "CAP cliente", "Comune_C": "Comune cliente",
  "Nazione_C": "Nazione cliente", "Divisa": "Valuta", "Numero_fattura": "N° fattura",
  "ImportoTotale": "Totale", "Data_pagamento": "Data pagamento", "Data_Acquisto": "Data acquisto",
  "oggetto_acquistato": "Oggetto acquistato", "ProgressivoInvio":"Progressivo Invio"
};
 
const originalKeyMapping: { [key: string]: keyof OptionsState } = {
    "Numero_fattura": "originalNumero_fattura",
    "Indirizzo_P": "originalIndirizzo_P",
    "CAP_P": "originalCAP_P",
    "Comune_P": "originalComune_P",
    "IdPaese_T": "originalIdPaese_T",
    "IdCodice_T": "originalIdCodice_T",
    "IdPaese_P": "originalIdPaese_P",
    "IdCodice_P": "originalIdCodice_P",
};


const App = () => {
  
  const { errorAlert, warningAlert } = useConfirmToast();
  const { fileCaricati, tempoUtilizzo, dataIsLoad } = useFileCaricati();
  const navigate = useNavigate();
  const { anagraficaClienti, errorLog, storicoFile, email, userPhotoURL, clienti_invitati, userId, avvisoSetting, isDataLoad} = useFirestoreData();
  
  const { filesContext, clearFiles } = useFileContext();
  const [originalFileNames, setOriginalFileNames] = useState<string[]>([]);
  const [sessionStats, setSessionStats] = useState<{ time: number; count: number } | null>(null);
  const [clienti, setClienti] = useState(anagraficaClienti);
  const [errorL, setError] = useState(errorLog);
  const [files, setFiles] = useState<File[]>([]);
  const [filesSplitted, setFilesSplitted] = useState<File[]>([]);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [fileURLs, setFileURLs] = useState<Map<string, string>>(new Map());
  const [currentPage, setCurrentPage] = useState(1);
  const [numPages, setNumPages] = useState(0);
  const objectURLsRef = useRef<Map<string, string>>(new Map());
  const [formData] = useState<{ [fileName: string]: { [key: string]: string } }>({});  //, setFormData
  const textareaRefs = useRef<{ [key: string]: HTMLTextAreaElement | null }>({});
  const [fileStatuses, setFileStatuses] = useState<Map<string, boolean | undefined>>(new Map());
  const [fileData, setFileData] = useState<Map<string, any>>(new Map());
  const [isProcessing, setIsProcessing] = useState(false);
  const [totalFiles, setTotalFiles] = useState(0);
  const processAppRef = useRef<ProgressApp | null>(null);
  const [modalAnagrafica, setModalAnagrafica] = useState<ReactNode | null>(null);
  const [modalRicalcola, setModalRicalcola] = useState<ReactNode | null>(null);
  const [showModalxml, setShowModalxml] = useState(false);
  const [duplicateModalInfo, setDuplicateModalInfo] = useState<{file: File; onContinue: () => void; onSkip: () => void;} | null>(null);
  const [isSplitterOpen, setIsSplitterOpen] = useState(false);
  const [hasDownloaded, setHasDownloaded] = useState(false); //è stato eseguito il download?
  const [showConfirmReloadModal, setShowConfirmReloadModal] = useState(false); // modale ricarica senza dowload
  const [dashboard, setDashboard] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null); // L'INPUT FILE 
  const clienteUid = sessionStorage.getItem('clienteUid') || '';
  const [avviso, setAvviso] = useState(false);
  const [PdfHelper, setPdfHelper] = useState(false);

  const ModaleTutorial = () => {
    return (
      <Dialog open={PdfHelper} onClose={()=>{}} sx={{p:0, m:0}}>
        <DialogTitle fontSize={28}>
          <div style={{display:'flex', userSelect:'none'}}>📚 Guida Rapida<div title="Per riaprire il tutorial clicca l'icona punto interrogativo in alto a destra."><Help/></div></div>
          <button className="Xclose" onClick={()=>setPdfHelper(false)} style={{position:"absolute", top:0 , right:0, userSelect:'none'}}>✕</button>
        </DialogTitle>
        <DialogContent sx={{p:0}}>
          <PdfHelperTutorial
            isVisible={PdfHelper}
            onClose={() => setPdfHelper(false)}
          />
        </DialogContent>
        <DialogActions sx={{p:0}}/>
      </Dialog>
    );
  };

  // rendiamo disponibile il tutorial
  useEffect(() => {
    const showHelper = async () => {
      if (isDataLoad && !avvisoSetting) {
        setPdfHelper(true);
      }
    }; 
    showHelper();
  }, [isDataLoad, avvisoSetting])

  // mostriamo l'avviso
  useEffect(() => {
    const showAvviso = async () => {
      if (isDataLoad && !avvisoSetting) {
        setAvviso(true);
        await ChangeOneVariable("avviso_setting", true);
      }
    }; 
    showAvviso();
  }, [isDataLoad, avvisoSetting])

  const [optionsState, setOptionsState] = useState<OptionsState>(initialOptions);
  
  // Sovrascrive lo stato iniziale con quello trovato in 
  useEffect(() => {
    try {
      const storedState = localStorage.getItem('userOptionsState');
      if (storedState) {
        setOptionsState(JSON.parse(storedState));
      }
    } catch (error) {
      console.error("Errore nel caricamento dello stato da localStorage:", error);
    }
  }, []);


  // aggiungiamo le anagrafiche dei clienti invitati tra le anagrafiche utilizzate nelle fatture
  useEffect(() => {
    if (!isDataLoad || !clienti_invitati || !anagraficaClienti) return;

    const syncAnagrafiche = async () => {
      for (const cliente of clienti_invitati) {
        const exists = anagraficaClienti.some(
          (c) => c.partita_iva === cliente.partita_iva
        );
        if (!exists) {
          const anagrafica = {
            Denominazione: String(cliente.ragione_sociale),
            partita_iva: String(cliente.partita_iva),
            indirizzo: String(cliente.indirizzo),
            cap: String(cliente.cap),
            comune: String(cliente.comune),
            nazione: String(cliente.nazione)
          };

          await addCliente(anagrafica);
        }
      }
    };

    syncAnagrafiche();
  }, [isDataLoad, clienti_invitati]); //anagraficaClienti
  

   useEffect(() => {

    if (!auth || !realtimeDb) return;

    const unsubAuth = onAuthStateChanged(auth, (user) => {
        if (user) {
            const userUid = user.uid;
            const databaseRefForPresence = databaseRef(realtimeDb, `presenza/${userUid}`);
            const connectedRef = databaseRef(realtimeDb, '.info/connected');

            const onDisconnectRef = onDisconnect(databaseRefForPresence);

            onDisconnectRef.update({
                ultimoAccessoTimestamp: new Date().toISOString()
            }).catch(error => console.error("Errore nell'impostare onDisconnect:", error));

            const unsubConnected = onValue(connectedRef, (snap) => {
                if (snap.val() === true) {
                    onDisconnectRef.cancel(); 

                    update(databaseRefForPresence, {
                        ultimoAccessoTimestamp: 'online'
                    }).catch(error => console.error("Errore nell'aggiornare a online:", error));

                    onDisconnectRef.update({
                        ultimoAccessoTimestamp: new Date().toISOString()
                    }).catch(error => console.error("Errore nel ristabilire onDisconnect:", error));

                } else {}
            });

            const cleanupPresence = () => {
                unsubConnected(); 
                onDisconnectRef.cancel(); 
            };

            return cleanupPresence;

        } else {}
        
        return undefined; 
    });

    return () => unsubAuth();
}, [auth, realtimeDb]);

  //gestiamo i duplicati
  async function calculateFileHash(file: File): Promise<string> {
    const arrayBuffer = await file.arrayBuffer(); 
    const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer); // Calcola hash

    //converti arrayBuffer in stringa esadecimale
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
  }

  //bottone Aggiorna Anagrafica
  const handleUpdateClick = () => {
    setModalAnagrafica(true)  
  };
  
  // bottone ricalcolo valuta
  const handleRicalcolawindow = (fileName:string) =>{
    const data= fileData.get(fileName)
    if (!data) {
      warningAlert(`Dati non trovati per il file: ${fileName}`);
      return; 
    }
    const { data_dict, origTotalImport, origValuta } = data;
    const TotalImport = parseFloat(origTotalImport); 
    setModalRicalcola(
      <ModalRecalculateC
        onClose={() => setModalRicalcola(null)}
        importoTotale={TotalImport}
        valuta={origValuta}
        dataPagamento={data_dict.Data_pagamento}
        fileName={fileName}
        setDataDict={handleInputChange} 
      />
    );
  };

  const goToPreviousPage = () => setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev));
  const goToNextPage = () => setCurrentPage((prev) => (prev < numPages ? prev + 1 : prev));

  const tooltips: { [key: string]: string } = {
    IdPaese_T: " I primi due caratteri della Partita IVA\ndel ente che trasmette la fattura. ",
    IdPaese_P: " I primi due caratteri della Partita IVA del fornitore. ",
    IdPaese_C: " I primi due caratteri della Partita IVA del cliente. ",
    IdCodice_T: "Identificativo numerico della Partita IVA\ndel ente che trasmette la fattura.",
    IdCodice_P: "Identificativo numerico della Partita IVA del fornitore. ",
    IdCodice_C: "Identificativo numerico della Partita IVA del cliente. ",
    ProgressivoInvio: "Codice identificativo della fattura generato randomicamente."
  };

   //Funzione per avviare la conversione di PDF divisi
  useEffect(() => {
    if (filesSplitted && filesSplitted.length > 0) {
      setTotalFiles(filesSplitted.length);
      setIsProcessing(true);
      processSequentially(filesSplitted, true);
      setFilesSplitted([]);
    }
  }, [filesSplitted]);

  //Funzione per avviare la conversione dei file nel contesto
  useEffect(() => {
    if (isDataLoad && userId && filesContext && filesContext.length > 0){
      setTotalFiles(filesContext.length);
      setIsProcessing(true);
      processSequentially(filesContext, true);
    }
  }, [filesContext, isDataLoad, userId]);


  // Funzione per processare ogni file
  const processFileAndUpdateState = async (file: File,  anagraficaClienti: any[], originalFileName:string) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('anagrafica', JSON.stringify(anagraficaClienti));
    const fileName = file.name;
    // Chiama la funzione di processamento per ottenere i dati
    try {                          
      const response = await fetch(process.env.REACT_APP_ESTRATTORE_BACKEND, {   
        method: 'POST',                                              
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to process the file');
      }

      const data = await response.json();
      if (data) {
        const { data_dict, errore, hasTextContent} = data
        const origTotalImport = data_dict.ImportoTotale
        const origValuta = data_dict.Divisa

        // Aggiungi i dati del file a fileData
        setFileData(prev => new Map(prev).set(fileName, { data_dict, origTotalImport, origValuta, originalFileName }));
        
        // calcoliamo il cambio valuta
        if (data_dict.Divisa !== "EUR"){
          await handleRicalcola(
            data_dict.ImportoTotale,
            data_dict.Divisa,
            data_dict.Data_pagamento,
            fileName,
            () => {}, // Nessuna modale da chiudere
            (key, value) => {
              data_dict[key] = value;
              handleInputChange(key, value);
            },
            warningAlert
          );
        }

        setFileStatuses(prev => {
          const updated = new Map(prev);
          updated.set(fileName, !!hasTextContent); // true se ha testo, false se è scansione
          return updated;
        });

        // Aggiungi il file alla lista dei file processati
        setFiles(prevFiles => {
          if (!prevFiles.find(f => f.name === file.name)) {
            return [...prevFiles, file];
          }
          return prevFiles;
        });


        if (errore) {
          errore.forEach((err:string)=> {
            if(err=="Errore durante l'elaborazione: EOF marker not found"){
              addErrorLog("", err);
            }else{
              addErrorLog("", err);
              errorAlert(`${err}`)
            }
          });
        }
      }

    } catch (error:any) {
      addErrorLog('Impossibile connettersi al web service: Controlla la connessione o richiedi assistenza.', error);
      setIsProcessing(false)
      errorAlert(`Controlla la connessione o richiedi assistenza.`,'Impossibile connettersi al web service');
    };
  };


  // rinomina il nome dei file
  const Rename = (originalName: string, index: number): string => {
    const baseName = originalName.replace(/\.[^/.]+$/, ""); // rimuove estensione
    const alphanumeric = baseName.replace(/[^a-zA-Z0-9]/g, ""); // solo lettere e numeri
    const truncated = alphanumeric.substring(0, 29); 
    return `${truncated}${index + 1}`;
  };

  // gestisce la sceta nella modale per i duplicati
  const askUserToContinueDuplicate = (file: File): Promise<boolean> => {
    return new Promise((resolve) => {
      setDuplicateModalInfo({
        file,
        onContinue: () => {
          setDuplicateModalInfo(null);
          resolve(true); // l’utente vuole continuare
        },
        onSkip: () => {
          setDuplicateModalInfo(null);
          resolve(false); // l’utente vuole saltare
        }
      });
    });
  };

  
  // gestisce l'invio dei file in modo sequenziale
  const processSequentially = async (selected:File[], noModName:boolean) => {
    const startTime = Date.now();

    const newUrls = new Map<string, string>();
    const processedFiles: File[] = [];
    
    let nameF="";
    const names: string[] = [];
    for (let i = 0; i < selected.length; i++) {
      const originalFile = selected[i];
      names.push(originalFile.name)
      if (noModName && (originalFile.name.length - 4 ) <= 30){
        nameF = Rename(originalFile.name, i).slice(0, -1);
      } else {
        nameF = Rename(originalFile.name, i);
      }
      const FileNamed = new File([originalFile], nameF, { type: originalFile.type });
      //const FileNamed = new File([originalFile.slice(0, originalFile.size)], nameF, { type: originalFile.type });

      const url = URL.createObjectURL(FileNamed);
      const hash = await calculateFileHash(FileNamed);
     
      const isDuplicate = storicoFile.some(obj => hash in obj);

      if (isDuplicate) {
        const shouldContinue = await askUserToContinueDuplicate(FileNamed);
        if (!shouldContinue) {
          continue; // salta il file
        }
      }

      saveHash(hash);

      await processFileAndUpdateState(FileNamed, anagraficaClienti, originalFile.name);

      newUrls.set(nameF, url);
      processedFiles.push(FileNamed);

      if (processAppRef.current) {
        processAppRef.current.fileProcessed();
      }
    }
    
    const timeInSession = Math.round((Date.now() - startTime) / 1000);
    const countInSession = processedFiles.length;
    setOriginalFileNames(names);
    setFiles(processedFiles);
    setFileURLs(newUrls);
    objectURLsRef.current = newUrls;
    setSelectedFile(null);
    setCurrentPage(1);
    setIsProcessing(false);
    clearFiles();
    setSessionStats({
        time: timeInSession,
        count: countInSession,
    });
  };


  // aggiungiamo le nuove statistiche
  useEffect(() => {
    if (dataIsLoad && sessionStats) {
        
      const timeInSeconds = Number(tempoUtilizzo) + sessionStats.time;
      salvaStatisticheUtilizzo(timeInSeconds, "statistiche_utente.tempoUtilizzoSecondi");
        
      const newFileCount = Number(fileCaricati) + sessionStats.count;
      salvaStatisticheUtilizzo(newFileCount, "statistiche_utente.fileCaricati");

      setSessionStats(null);
    }
  }, [dataIsLoad, sessionStats, tempoUtilizzo, fileCaricati]);


  // Funzione helper per aprire l'input 
  const openFileInput = () => {
    if (fileInputRef.current) {
        fileInputRef.current.click();
    }
  };

 
// gestore del click per 'Carica PDF'
  const handleOpenFileInput = () => {
     if (files.length > 0 && !hasDownloaded) {
        // Mostra la modale di conferma 
        setShowConfirmReloadModal(true); 
    } else {
      openFileInput();
    }
  };

  // gestore del click per 'sulla dashboard'
  const handleOpenDashboard = () => {
     if (files.length > 0 && !hasDownloaded) {
        // Mostra la modale di conferma 
        setShowConfirmReloadModal(true); 
    } else {
      navigate('/dashboard');
    }
  };


  // gestisce il fusso dei file
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selected = event.target.files ? Array.from(event.target.files) : [];
    if (selected.length === 0) return;
    
    setHasDownloaded(false);
    setFiles([]);
    setFileURLs(new Map());
    setTotalFiles(selected.length);
    setIsProcessing(true);
     
    processSequentially(selected, false).catch((error) => {
      errorAlert(error, "Errore durante il processo:");
      addErrorLog("Errore durante il processo:", error);
      setIsProcessing(false);
    });
    sessionStorage.setItem('originalFileNames', JSON.stringify(originalFileNames));
  };

  // Logica per gestire la conferma nella modale
  const handleConfirmReload = (shouldContinue: boolean , dashboard:boolean) => {
    setShowConfirmReloadModal(false);
    if (shouldContinue && !dashboard) {
        openFileInput();
    } else if (shouldContinue && dashboard){
        setDashboard(false);
        navigate('/dashboard');
    }
  };

  // click sui singoli file nella lista
  const handleFileClick = (file: File) => {
    setSelectedFile(file);
    setCurrentPage(1);
  };


  // Entry
  const renderEntries = (dataDict: any, handleInputChange: (key: string, value: string) => void, optionsState: OptionsState) => {
    return Object.keys(keysMapping).map((key) => {
      if (dataDict.hasOwnProperty(key)) {
        let displayValue = String(dataDict[key]);
        const originalStateKey = originalKeyMapping[key];
        if (originalStateKey && optionsState[originalStateKey] === true) {
          const alternateKey = originalStateKey; 
          if (dataDict.hasOwnProperty(alternateKey)) {
            displayValue = String(dataDict[alternateKey]);
          }
        }
        return (
          <div key={key} className="form-row">
            <label 
              className="form-label"
              data-tooltip-id={`tooltip-${key}`}
              data-tooltip-content={tooltips[key]}
            >
              {keysMapping[key] || key}
            </label>
            <TextareaAutosize
              ref={(el) => {(textareaRefs.current[key] = el)}}
              className="form-input"
              value={displayValue}//String(dataDict[key])}
              onChange={(e) => handleInputChange(key, e.target.value)}
              rows={1}
              autoComplete="off"
              spellCheck={false}
              autoCorrect="off"
            />
            {tooltips[key] && (
              <Tooltip id={`tooltip-${key}`} place="top"/>
            )}
          </div>
        );
      }
      return null;
    });
  };

  //salva le modifiche
  const handleInputChange = (key: string, value: string) => {
    if (!selectedFile) return;
    setFileData((prevData) => {
      const updatedData = new Map(prevData);
      const fileDataCopy = { ...updatedData.get(selectedFile.name) };
      fileDataCopy.data_dict = {
        ...fileDataCopy.data_dict,
        [key]: value,
      };
      updatedData.set(selectedFile.name, fileDataCopy);
      return updatedData;
    });
  };

  //scambia cliente-fornitore
  const handleButtonClick = () => {
    if (!selectedFile) return;

    setFileData((prevData) => {
      const updatedData = new Map(prevData);
      const fileDataCopy = { ...updatedData.get(selectedFile.name) };
      const dataDict = fileDataCopy.data_dict;
      // Scambia i dati
      const newDataDict = {
        ...dataDict,
        IdPaese_C: dataDict.IdPaese_P,
        IdCodice_C: dataDict.IdCodice_P,
        Denominazione_C: dataDict.Denominazione_P,
        Indirizzo_C: dataDict.Indirizzo_P,
        CAP_C: dataDict.CAP_P,
        Comune_C: dataDict.Comune_P,
        Nazione_C: dataDict.Nazione_P,

        IdPaese_P: dataDict.IdPaese_C,
        IdCodice_P: dataDict.IdCodice_C,
        Denominazione_P: dataDict.Denominazione_C,
        Indirizzo_P: dataDict.Indirizzo_C,
        CAP_P: dataDict.CAP_C,
        Comune_P: dataDict.Comune_C,
        Nazione_P: dataDict.Nazione_C,
      };

      fileDataCopy.data_dict = newDataDict;
      updatedData.set(selectedFile.name, fileDataCopy);
      return updatedData;
    });
  };

  const [showAnagrafica, setShowAnagrafica] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const updatedRef = useRef(new Set<string>()); // flag in memoria
  useEffect(() => {
    if (
      selectedFile &&
      fileData.has(selectedFile.name) &&
      !updatedRef.current.has(selectedFile.name)
    ) {
      const dataDict = fileData.get(selectedFile.name)?.data_dict;
      if (dataDict) {
        handleUpdateClick();
        updatedRef.current.add(selectedFile.name);
      }
    }
  }, [selectedFile, fileData]);

  useEffect(() => {
    setClienti(anagraficaClienti);
  }, [anagraficaClienti]);

  useEffect(() => {
    setError(errorLog);
  }, [errorLog]);

  useEffect(() => {
    Object.values(textareaRefs.current).forEach((textarea) => {
      if (textarea) {
        textarea.style.height = "auto";
        textarea.style.height = textarea.scrollHeight + "px";
      }
    });
  }, [formData]);


  const handleMultipleDownload = async() => {
    const filesToProcess = files.map(file => ({
      name: file.name,
      data: fileData.get(file.name)?.data_dict
    }));

    // conta i file e i relativi campi mancanti
    const missingDataFiles: { name: string, missingFields: string[] }[] = [];

    files.forEach(file => {
        const fileEntry = fileData.get(file.name);
        const dataDict = fileEntry?.data_dict; 

        //  Dati base mancanti (File non processato o errore API)
        if (!dataDict) {
            missingDataFiles.push({ name: file.name, missingFields: ['Dati di estrazione non disponibili'] });
            return;
        }
        
        //  Campi vuoti all'interno di dataDict (Controllo su TUTTE le chiavi)
        const currentMissingKeys = Object.keys(dataDict).filter(key => {
            const value = dataDict[key];
            // Filtra se il valore è falsy o è una stringa vuota dopo il trim
            return !value || String(value).trim() === ''; 
        });

        if (currentMissingKeys.length > 0) {
            // Mappa le chiavi mancanti nei nomi leggibili per l'utente (usando keysMapping)
            const missingFieldsReadable = currentMissingKeys.map(key => keysMapping[key] || key);
            missingDataFiles.push({ name: file.name, missingFields: missingFieldsReadable });
        }
    });

    if (missingDataFiles.length > 0) {
      //  Dati mancanti - Avvisa l'utente e blocca
      const detailsHtml = missingDataFiles.map(item => {
        const fieldsList = item.missingFields.map(field => `<li>- ${field}</li>`).join('');
        return `
          <p style="margin-bottom: 5px;">
            <strong>File: ${item.name}</strong>
            <ul style="list-style: none; padding-left: 15px; margin-top: 5px;">
              ${fieldsList}
            </ul>
          </p>
            `;
      }).join('<hr style="border: 0; border-top: 1px solid #eee; margin: 10px 0;">');

      const message = `
          <p><strong>Non è possibile generare gli XML.</strong></p>
          <p>Rivedi e completa tutti i dati nei seguenti file:</p>
          <div style="max-height: 200px; overflow-y: auto; padding: 10px; border: 1px solid #ddd; border-radius: 4px; margin-top: 10px;">
            ${detailsHtml}
          </div>
        `;
        
      warningAlert(message, "Dati Mancanti");
     } else if (files.length === 0) {
      //warningAlert('Nessun file da cui generare XML.');
    } 
    else {
      // Nessun dato mancante
      if (originalFileNames){
        for (const name of originalFileNames) {
          try{
          await aggiornaStatoFileCliente( clienteUid, name, String(userId), 'Elaborato');
        }catch(error){};
        }
      };
      filesToProcess.forEach((item) => {
        creaXmlFattura(item.data, item.name, errorAlert, warningAlert);
      });
      //sessionStorage.removeItem('clienteUid');
      setHasDownloaded(true); 
    }
  }

 return(
   <div style={{ display: 'flex', 
        height: '100vh', 
        fontFamily: 'Inter, sans-serif', 
        backgroundImage: "url('/sfondo_pdf_xml.png')", 
        backgroundPosition: "center top",
        backgroundSize: "100% 80%",
        backgroundRepeat: "no-repeat"
      }}
    >
      {/*LEFT SIDEBAR */}
      <aside style={{ 
          width: '15%', 
          minWidth: '215px', 
          backgroundColor: 'transparent', 
          padding: '1rem', 
          display: 'flex', 
          flexDirection: 'column', 
          gap: '1.5rem', 
          borderRight: '0', 
          boxShadow: '2px 0 5px -2px rgba(0, 0, 0, 0.05)',
      }}>
        <div style ={{display:'flex', justifyContent:'center', backgroundColor: '#0e2f70ff', borderRadius: '0.5rem', padding:'0.75rem'}}>
          <div style={{maxWidth:'2rem', width:'2rem', minWidth:'0.5rem', maxHeight:'0.1rem'}}></div>
          <label
            //htmlFor="file-upload"
            onClick={handleOpenFileInput} 
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth:'8rem',
              gap: '0.5rem',
              color: 'white',
              fontWeight: 'bold',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'background-color 0.3s ease',
              fontSize: '1rem',
            }}
            title="Carica uno o più file PDF">
            <CloudUploadIcon style={{ fontSize: '1.25rem' }} />
            Carica PDF
          </label>
          <div style={{maxWidth:'1rem', width:'1rem', minWidth:'0.5rem', maxHeight:'0.1rem'}}></div>
          <div
            onClick= {() => {setIsSplitterOpen(true)}}
            style={{
              display: 'flex',
              alignItems: 'center',
              cursor: "pointer",
              borderLeft: '1px solid #ebeae8ff',
              transition: "background 0.2s ease",
            }}
            title="Dividi un PDF in più file"
          >
            <MoreVertIcon sx={{marginLeft:'0.75rem', color:'white'}} />
          </div>
        </div>
        <input 
          ref={fileInputRef}
          id="file-upload" 
          type="file" 
          accept="application/pdf" 
          multiple 
          onChange={handleFileChange} 
          style={{ display: 'none' }} 
        />

        {/*LISTA FILE*/}
        <div style={{ 
            flex: 1, 
            overflowY: 'auto' 
        }}>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, borderRadius: '0.5rem', backgroundColor: '#f9fafb', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
              {files.map((file, index) => (
                <li
                  key={index}
                  onClick={() => handleFileClick(file)}
                  style={{
                    padding: '0.75rem 1rem',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid #e5e7eb',
                    transition: 'background-color 0.2s ease, color 0.2s ease',
                    backgroundColor: selectedFile?.name === file.name ? '#e5e7eb' : 'transparent',
                    color: selectedFile?.name === file.name ? '#1f2937' : '#374151',
                    fontWeight: selectedFile?.name === file.name ? '600' : '400',
                  }}
                >
                  <span style={{ wordBreak: 'break-word', marginRight: '0.5rem', flexGrow: 1}}>{file.name}</span>
                  {fileStatuses.get(file.name) === false && (
                    <span style={{ fontSize: '1.25rem', color: '#21659cff', display: 'flex', alignItems: 'center' }} title="PDF generato tramite scansione">
                      <WarningIcon style={{ fontSize: '1.25rem' }} />
                    </span>
                  )}
                </li>
              ))}
            </ul>
        </div>

        {/*GRUPPO BOTTONI (FISSO IN FONDO) */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', paddingTop: '0.5rem' }}>
            <button
              onClick={() => handleMultipleDownload() }
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                padding: '0.75rem 1rem',
                borderRadius: '0.5rem',
                backgroundColor: '#0e2f70ff',
                color: 'white',
                fontWeight: 'bold',
                border: 'none',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
              }}>
              <FileDownloadIcon style={{ fontSize: '1.25rem' }} />
              Scarica tutti XML
            </button>

            <button
              onClick={() => setShowAnagrafica(true)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                padding: '0.75rem 1rem',
                borderRadius: '0.5rem',
                backgroundColor: '#225094ff',
                color: 'white',
                fontWeight: 'bold',
                border: 'none',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
              }}>
              <DescriptionIcon style={{ fontSize: '1.25rem' }} />
              Anagrafica
            </button>

            <button
              onClick={() => setShowPopup(true)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem',
                padding: '0.75rem 1rem',
                borderRadius: '0.5rem',
                backgroundColor: '#21759cff',
                color: 'white',
                fontWeight: 'bold',
                border: 'none',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease',
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
              }}>
              <WarningIcon style={{ fontSize: '1.25rem' }} />
              Log degli errori
            </button>
        </div>
      </aside>

      {/* HEADER + MAIN CONTENT */}
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        
        {/* HEADER */}
        <header style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: '1rem 1.5rem', backgroundColor: 'transparent', color: '#1f2937', borderBottom: 0}}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <button 
              onClick={() => {setDashboard(true); handleOpenDashboard()}} 
              style={{border:0, borderRadius:'24px', cursor:'pointer', display:'flex', flexDirection:'row', alignItems:'center',justifyContent:'space-between',backgroundColor:'#fff', padding:'2px'}}
            >
              <Avatar 
                src={userPhotoURL ? userPhotoURL : ""} 
                style={{ width: 40, height: 40, border: '0', borderRadius: '50%'}} 
                title={String(email)}
              />
              <p style={{margin:'0 0.7rem 0 0.5rem', color:'#004d8bff', fontFamily: 'Segoe UI', fontWeight:600, fontSize:17}}>Profilo</p>
            </button>
            <IconButton onClick={()=>setPdfHelper(true)} sx={{padding:'1px'}}><Help style={{ height:'1.7rem',width:'1.7rem', color:'#fff'}}/></IconButton>
          </div>
        </header>

        {/* MAIN CONTENT AREA */}
        <main 
          style={{ 
            flex: 1,
            overflow: 'hidden', 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            backgroundColor: selectedFile ? "#f4f4f7" : "transparent", 
            borderRadius: '6px', 
            transition: "background-color 0.3s ease" 
          }}
        >
          {isProcessing ? (
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(43, 42, 42, 0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
              <div style={{ backgroundColor: 'white', padding: '2rem', borderRadius: '0.75rem', textAlign: 'center', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)' }}>
                <ProgressApp totalFiles={totalFiles} gifPath="./Spinner@1x-1.0s-200px-200px.gif" onClose={() => {}}/>
              </div>
            </div>
          ) :  (
            <AnimatePresence mode="wait">
              {selectedFile ? (
                <motion.div
                  key={selectedFile.name}
                  initial={{ y: 50, opacity: 0 }}   // parte dal basso e invisibile
                  animate={{ y: 0, opacity: 1 }}    // entra visibile
                  exit={{ y: 50, opacity: 0 }}      // esce scendendo 
                  transition={{ duration: 0.25, ease: "easeOut" }} 
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "1.5rem",
                    width: "100%",
                    height: "100%"
                  }}
                >
                  <div 
                    style={{
                      display: 'grid',
                      padding:'1.5rem',
                      gridTemplateColumns: '50% 50%', 
                      gridTemplateRows:'100%',
                      gap: '1rem',
                      width: '99%',
                      maxWidth: '100%',
                      height: '100%',
                    }}
                  >
                    {/* PDF Viewer and Controls */}
                    <div 
                      style={{ 
                        display: 'grid',
                        gridTemplateRows: '90% 10%',
                        gap: '0.75rem',
                        backgroundColor: 'white',
                        padding: '1.5rem',
                        borderRadius: '0.75rem',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
                        position: 'relative',
                      }}
                    >
                      <div 
                        style={{
                          flex: 1,
                          minHeight: 0,
                          maxWidth:'100%',
                          overflow: "auto", 
                          borderRadius: "0.5rem",
                          border: "1px solid #d1d5db",
                          position: "relative",
                          backgroundColor: "#fff",
                        }}
                      >
                        {fileURLs.has(selectedFile.name) && (
                          <PdfViewer
                            file={fileURLs.get(selectedFile.name)!}
                            currentPage={currentPage} 
                            setNumPages={setNumPages}
                          />
                        )}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0.5rem 0' }}>
                        <button
                          onClick={goToPreviousPage}
                          disabled={currentPage === 1}
                          style={{
                            padding: '0.5rem 1rem',
                            borderRadius: '0.5rem',
                            backgroundColor: '#173a80ff',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                            opacity: currentPage === 1 ? 0.6 : 1,
                          }}
                        >
                          Precedente
                        </button>
                        <div style={{ color: '#4b5563', fontWeight: '600' }}>
                          Pagina {currentPage} di {numPages}
                        </div>
                        <button
                          onClick={goToNextPage}
                          disabled={currentPage === numPages}
                          style={{
                            padding: '0.5rem 1rem',
                            borderRadius: '0.5rem',
                            backgroundColor: '#173a80ff',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                            opacity: currentPage === numPages ? 0.6 : 1,
                          }}
                        >
                          Successiva
                        </button>
                      </div>
                    </div>
                    {/* Data Entry */}
                    <div 
                      style={{ 
                        display: 'flex', 
                        flexDirection: 'column', 
                        gap: '0.75rem', 
                        backgroundColor: 'white', 
                        padding: '1.5rem',
                        paddingTop:'0.8rem', 
                        borderRadius: '0.75rem', 
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)', 
                        overflow: 'hidden', 
                        position: 'relative' 
                      }}
                    >
                      {/* GRUPPO BOTTONI IN LINEA FISSI IN ALTO */}
                      <div 
                        style={{ 
                          position: 'sticky', 
                          top: 0, 
                          zIndex: 10, 
                          display: 'flex', 
                          justifyContent: 'flex-end', 
                          gap: '0.5rem', 
                          paddingBottom: '0.7rem', 
                          backgroundColor: 'white', 
                          borderBottom: '1px solid #e5e7eb'
                        }}
                      >
                        {/* Aggiorna Anagrafica - Icona 'A' */}
                        <button
                          onClick={() => handleUpdateClick()}
                          title="Aggiorna Anagrafica" 
                          style={{
                            padding: '0.5rem',
                            width: '2rem', 
                            height: '2rem', 
                            borderRadius: '0.5rem',
                            backgroundColor: '#173a80ff',
                            color: 'white',
                            fontWeight: 'bold',
                            border: 'none',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            fontSize: '1rem',
                            userSelect:'none' 
                          }}
                        >
                          A
                        </button>
                        {/* Cliente / Fornitore - Icona SwapHorizIcon */}
                        <button
                          onClick={handleButtonClick}
                          title="Cliente / Fornitore" 
                          style={{
                            padding: '0.5rem',
                            width: '2rem',
                            height: '2rem',
                            borderRadius: '0.5rem',
                            backgroundColor: '#305fa5ff',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center'
                          }}
                        >
                          <SwapHorizIcon style={{ fontSize: '1rem' }} />
                        </button>
                        {/* Cambio valuta - Icona CurrencyExchangeIcon */}
                        <button
                          onClick={() => handleRicalcolawindow(selectedFile.name)}
                          title="Cambio valuta" 
                          style={{
                            padding: '0.5rem',
                            width: '2rem',
                            height: '2rem',
                            borderRadius: '0.5rem',
                            backgroundColor: '#305fa5ff',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center'
                          }}
                        >
                          <CurrencyExchangeIcon style={{ fontSize: '1rem' }} />
                        </button>
                        {/* Modifica XML - Icona EditIcon */}
                        <button
                          onClick={() => setShowModalxml(true)}
                          title="Modifica XML" 
                          style={{
                            padding: '0.5rem',
                            width: '2rem',
                            height: '2rem',
                            borderRadius: '0.5rem',
                            backgroundColor: '#305fa5ff',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            transition: 'background-color 0.3s ease',
                            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center'
                          }}
                        >
                          <EditIcon style={{ fontSize: '1rem' }} />
                        </button>
                      </div>

                      {/* Visualizzazione dei dati */}
                      <div 
                        style={{ 
                          flex: 1, 
                          padding: '0.8rem', 
                          borderRadius: '0.5rem', 
                          border: '1px solid #d1d5db', 
                          overflowY: 'auto', 
                          backgroundColor: '#f9fafb',
                          height: '100%' 
                        }}
                      >
                        {fileData.has(selectedFile.name) && renderEntries(fileData.get(selectedFile.name)?.data_dict || {}, handleInputChange, optionsState)}
                      </div>
                
                      {/* Messaggio Tasso di cambio */}
                      <div 
                        style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center',
                          padding: '0.75rem 1rem',
                          borderRadius: '0.5rem',
                          backgroundColor: '#eef2ff', 
                          color: '#173a80ff', 
                          fontWeight: '600',
                          border: '1px solid #c7d2fe',
                          textAlign: 'center'
                        }}
                      >
                        {messageBox(selectedFile.name)}
                      </div>
                    </div>
                  </div>
                </motion.div>
              ) : (
                <motion.div
                  key="empty"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    color: "#9ca3af",
                    fontSize: "1.5rem",
                    textAlign: "center",
                    fontWeight: "500"
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#9ca3af', fontSize: '1.5rem', textAlign: 'center', fontWeight: '500', userSelect:'none' }}>
                    <p>Carica uno o più file.<br/>
                    Selezionalo dalla lista a sinistra per visualizzarlo.</p>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          )}
        </main>
      </div>

      {/* Modali */}
      <Dialog open={avviso} maxWidth='md'>
        <DialogTitle sx={{fontWeight:600, fontSize:24}}>Benvenuto/a !</DialogTitle>
        <Divider sx={{margin:'0 2rem 0 2rem'}}/>
        <DialogContent>
          <div style={{padding:'1rem'}}>Grazie per aver scelto <strong>AutoFattura.pro .</strong><br/><br/>
          Per garantirti la massima <strong>efficienza</strong> e <strong>semplificare</strong> l'integrazione dei dati 
          estratti con i sistemi di registrazione delle fatture, abbiamo <strong>pre-selezionato alcuni parametri</strong> di formattazione dei dati estratti dalle fatture.<br/>
          Questo passaggio è fondamentale: ci assicura che i dati, una volta estratti, siano compatibili con specifici canali di destinazione 
          che potrebbero non accettare i valori originali (ad esempio, a causa di caratteri speciali o lunghezze eccessive).<br/><br/>
          Puoi modificare queste impostazioni in qualsiasi momento:<br/>
          <strong style={{margin:'0 0.6rem 0 0.7rem'}}>1.</strong>Clicca su <strong>"Profilo"</strong> in alto a destra.<br/>
          <div style={{display:'flex', alignItems:'center'}}>
            <strong style={{margin:'0 0.6rem 0 0.7rem'}}>2.</strong>Seleziona l'icona <ManageAccounts sx={{ml:'0.5rem'}}/>.
          </div><br/><br/>
          Buon lavoro, Il Team di AutoFattura.pro.</div>
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' sx={{fontWeight:600}} onClick={() => setAvviso(false)}>OK</Button>
        </DialogActions>
      </Dialog>
      {showAnagrafica && (
        <AnagraficApp anagraficaClienti={clienti} updateAnagraficaClienti={setClienti} onClose={() => setShowAnagrafica(false)} />
      )}
      <ErrorPopup isOpen={showPopup} onClose={() => setShowPopup(false)} errorLog={errorL} />
      {duplicateModalInfo && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ backgroundColor: 'white', padding: '2rem', borderRadius: '0.75rem', textAlign: 'center', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', maxWidth: 'fit-content', position: 'relative' }}>
            <div style={{ paddingLeft: '1.5rem' , paddingBottom: '1.5rem', paddingRight: '1.5rem' }}>
              <h3 style={{ color: '#1f2937' }}>
                Il file <b>{duplicateModalInfo.file.name}</b>
              </h3>
              <p style={{ marginBottom: '1rem'}}>risulta essere già stato elaborato.</p>
              <p style={{ margin: 0 , fontWeight: 600}}>Vuoi saltare la sua elaborazione?</p>
            </div>
            <div style={{ marginLeft:'1.5rem',  marginRight:'1.5rem', borderTop: '1px solid #ccc', display: 'flex', gap: '1rem', justifyContent: 'center' }}>
              <button
                title='NON elaborare di nuovo questo file'
                onClick={duplicateModalInfo.onSkip}
                style={{
                  marginTop:'20px',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '4px',
                  backgroundColor: '#0e2f70ff',
                  color: 'white',
                  fontWeight: 'bold',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s ease',
                }}>
                Salta
              </button>
              <button
                title='ELABORA di nuovo questo file'
                onClick={duplicateModalInfo.onContinue}
                style={{
                  marginTop:'20px',
                  padding: '0.75rem 1.5rem',
                  borderRadius: '4px',
                  backgroundColor: '#ef4444',
                  color: 'white',
                  fontWeight: 'bold',
                  border: 'none',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s ease',
                }}>
                Continua
              </button>
            </div>
          </div>
        </div>
      )}
      {showConfirmReloadModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ backgroundColor: 'white', padding: '2rem', borderRadius: '0.75rem', textAlign: 'center', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)', maxWidth: 'fit-content', position: 'relative' }}>
            <h2>Alcuni file non sono ancora stati scaricati in formato XML.</h2>
            <br/>
            <p>Continuando con il caricamento, tutti i dati attualmente visualizzati verranno <strong style={{color:'#ef4444'}}>eliminati</strong>.<br/><strong>Vuoi procedere?</strong></p>
                
            <div style={{ marginLeft:'4rem',  marginRight:'4rem', borderTop: '1px solid #ccc', marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
              <button 
                onClick={() => handleConfirmReload(false, dashboard)} 
                style={{ marginTop:'20px', border: 0, borderRadius:'4px', padding: '10px 20px', backgroundColor: '#0e2f70ff', color: 'white' }}
              >
                Annulla
              </button>
              <button 
                onClick={() => handleConfirmReload(true, dashboard)} 
                style={{ marginTop:'20px', border: 0, borderRadius:'4px', padding: '10px 20px', backgroundColor: '#ef4444', color: 'white' }}
              >
                Continua
              </button>
            </div>
          </div>
        </div>
      )}
      {isSplitterOpen  && (
        <PdfSplitterModal
          isOpen={isSplitterOpen}
          onClose={() => setIsSplitterOpen(false)}
          onFilesReady={setFilesSplitted}
        />
      )}
      {selectedFile && (
        <>
          {modalAnagrafica && (
            <AggiornaAnagrafica
              data_dict={fileData.get(selectedFile.name).data_dict}
              anagraficaClienti={clienti}
              setClienti={setClienti}
              onClose={() => setModalAnagrafica(null)}
              setDataDict={handleInputChange}
            />
          )}
          {modalRicalcola}
          {showModalxml && ( 
            <XmlEditorModal
              isOpen={showModalxml}
              onClose={() => setShowModalxml(false)}
              selectedFile={selectedFile}
              fileData={fileData}
              setFileData={setFileData}
            />
          )}
        </>
      )}
      {!avviso && (<ModaleTutorial/>)}
    </div>
  );
}

export default App;
